import { NeoModel, ModelBase } from '@singularsystems/neo-core';
@NeoModel
export default class ClientAccountLookup extends ModelBase {

    public clientAccountId: number = 0;

    public clientId: number = 0;

    public staticServiceProviderFileGroupingId: number | null = null;

    public brokerName: string = "";

    public serviceProviderAccountNumber: string = "";

    public activeInactive: string = "";

    public brokerDescription: string = "";
    
    public switchProperty: boolean = true;
}